export default __webpack_public_path__ + "static/media/Md_Majharul_Islam-removebg-preview.bd714f63.png";